import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { useRegionalLink } from 'hooks/useRegionalLink';

import { ReactComponent as LogoSVG } from 'assets/svg/jarvis.svg';

import classes from './Logo.module.scss';

const Logo = () => {
  const generateRegionalPath = useRegionalLink();
  return (
    <Link to={generateRegionalPath('/')} className={classes.logo}>
      <LogoSVG height="32" aria-label="Link to the home page" />
    </Link>
  );
};

export default memo(Logo);
